// extracted by mini-css-extract-plugin
export var bubble = "_44-0";
export var container = "_44-f";
export var contrastBorder = "_44-g";
export var greyOut = "_44-2";
export var initialsColor0 = "_44-3";
export var initialsColor1 = "_44-4";
export var initialsColor10 = "_44-d";
export var initialsColor11 = "_44-e";
export var initialsColor2 = "_44-5";
export var initialsColor3 = "_44-6";
export var initialsColor4 = "_44-7";
export var initialsColor5 = "_44-8";
export var initialsColor6 = "_44-9";
export var initialsColor7 = "_44-a";
export var initialsColor8 = "_44-b";
export var initialsColor9 = "_44-c";
export var initialsWrapper = "_44-1";
export var large = "_44-l";
export var medium = "_44-k";
export var mediumSmall = "_44-j";
export var mediumSmallMedium = "_44-o";
export var micro = "_44-h";
export var small = "_44-i";
export var tiny = "_44-n";
export var xTiny = "_44-m";